
// Data for Gas Analytics charts and visualizations

export const consumptionData = [
  { name: 'Jan', consumption: 520 },
  { name: 'Feb', consumption: 490 },
  { name: 'Mar', consumption: 440 },
  { name: 'Apr', consumption: 380 },
  { name: 'May', consumption: 320 },
  { name: 'Jun', consumption: 290 },
  { name: 'Jul', consumption: 270 },
  { name: 'Aug', consumption: 290 },
  { name: 'Sep', consumption: 350 },
  { name: 'Oct', consumption: 420 },
  { name: 'Nov', consumption: 480 },
  { name: 'Dec', consumption: 510 },
];

export const pressureData = [
  { time: '00:00', pressure: 2.15 },
  { time: '02:00', pressure: 2.16 },
  { time: '04:00', pressure: 2.17 },
  { time: '06:00', pressure: 2.18 },
  { time: '08:00', pressure: 2.20 },
  { time: '10:00', pressure: 2.19 },
  { time: '12:00', pressure: 2.18 },
  { time: '14:00', pressure: 2.16 },
  { time: '16:00', pressure: 2.15 },
  { time: '18:00', pressure: 2.14 },
  { time: '20:00', pressure: 2.16 },
  { time: '22:00', pressure: 2.15 },
];

export const gasFlowData = [
  { time: '00:00', flow: 35 },
  { time: '02:00', flow: 30 },
  { time: '04:00', flow: 25 },
  { time: '06:00', flow: 40 },
  { time: '08:00', flow: 60 },
  { time: '10:00', flow: 65 },
  { time: '12:00', flow: 70 },
  { time: '14:00', flow: 68 },
  { time: '16:00', flow: 65 },
  { time: '18:00', flow: 72 },
  { time: '20:00', flow: 45 },
  { time: '22:00', flow: 40 },
];

export const gasDistribution = [
  { name: 'Heating', value: 55 },
  { name: 'Cooking', value: 25 },
  { name: 'Hot Water', value: 15 },
  { name: 'Other', value: 5 },
];

export const COLORS = ['#F97316', '#FBBF24', '#FB923C', '#FDBA74'];

export const recentAlarms = [
  { id: 1, device: 'Main Gas Line', issue: 'Pressure Drop', severity: 'High', time: '3 hours ago' },
  { id: 2, device: 'Kitchen Supply', issue: 'Flow Fluctuation', severity: 'Medium', time: '8 hours ago' },
  { id: 3, device: 'Heating System', issue: 'Low Pressure', severity: 'Low', time: '1 day ago' },
  { id: 4, device: 'Boiler Room', issue: 'Connection Issue', severity: 'Medium', time: '3 days ago' },
];

export const getSeverityColor = (severity: string) => {
  switch (severity) {
    case 'High': return 'text-energy-red';
    case 'Medium': return 'text-amber-500';
    case 'Low': return 'text-energy-green';
    default: return 'text-gray-500';
  }
};
